module.exports = __webpack_public_path__ + "img/team.4d7e004e.png";